import styled from '@emotion/styled';
import { HashRouter as Router } from 'react-router-dom';

import Footer from '@components/Footer';
import Header from '@components/Header';
import Content from '@context/Content';
import { AccountProvider } from '@hooks/AccountContext';
import { SHOW_HEADER } from '@utils/globals';

const AppContainer = styled.div(() => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
}));

function App() {
    return (
        <Router>
            <AppContainer>
                <AccountProvider>
                    {SHOW_HEADER ? <Header /> : null}
                    <Content />
                    <Footer style={{ alignSelf: 'flex-end' }} />
                </AccountProvider>
            </AppContainer>
        </Router>
    );
}

export default App;
